export var AttributeLayout;
(function (AttributeLayout) {
    AttributeLayout[AttributeLayout["POSITION"] = 0] = "POSITION";
    AttributeLayout[AttributeLayout["NORMAL"] = 1] = "NORMAL";
    AttributeLayout[AttributeLayout["TANGENT"] = 2] = "TANGENT";
    AttributeLayout[AttributeLayout["TEXCOORD_0"] = 3] = "TEXCOORD_0";
    AttributeLayout[AttributeLayout["TEXCOORD_1"] = 4] = "TEXCOORD_1";
    AttributeLayout[AttributeLayout["COLOR_0"] = 5] = "COLOR_0";
    AttributeLayout[AttributeLayout["JOINTS_0"] = 6] = "JOINTS_0";
    AttributeLayout[AttributeLayout["WEIGHTS_0"] = 7] = "WEIGHTS_0";
})(AttributeLayout || (AttributeLayout = {}));
;
//# sourceMappingURL=attribute-layout.js.map